import uploadFileToS3 from '../../../Common/Auth/Handler/uploadFileToS3';

const uploadMultipleFile = async ({ inputData, uploadPath = '' }) => {
  const documentsPromises = inputData.doc.map(async doc => {
    const documentFile = doc?.file_url;
    // Upload file if it's a File object
    if (documentFile instanceof File) {
      const uploadFileResult = await uploadFileToS3({
        file: documentFile,
        uploadPath,
      });
      doc.file_url = uploadFileResult;
      doc.updated = true; // Mark as updated
      return uploadFileResult;
    }
    if (typeof documentFile === 'string') {
      // If it's already a URL, skip upload
      return documentFile;
    }
    return null;
  });

  // Wait for all file uploads to complete
  await Promise.all(documentsPromises);

  return inputData;
};

export default uploadMultipleFile;
